// extracted by mini-css-extract-plugin
export var divider = "_gd-7";
export var itemsToggle = "_gd-8";
export var mergeModal = "_gd-1";
export var optionCard = "_gd-4";
export var radioGroup = "_gd-6";
export var radioOption = "_gd-0";
export var selected = "_gd-5";
export var shipmentOptions = "_gd-2";
export var tableOptions = "_gd-3";